import { render, staticRenderFns } from "./Pacman.vue?vue&type=template&id=74a5c968&scoped=true&"
var script = {}
import style0 from "./Pacman.vue?vue&type=style&index=0&id=74a5c968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5c968",
  null
  
)

export default component.exports